import { schemaGenerator } from "../utils";

const dictionary = {
  regular: {
    default: [
      "tw-inline-flex",
      "tw-flex-col",
      "tw-flex-wrap",
      "tw-justify-start",
      "tw-items-center",
      "tw-border-0",
      "tw-border-solid",
      "tw-border-r-[1px]",
      "tw-border-neutral-gray-10",
    ],
  },
};

const schema = schemaGenerator(dictionary);

export default schema;
